export const newsEnabled = process.env.VUE_APP_MANAGER_NEWS_ENABLED !== 'false'
export const hhServicesEnabled = process.env.VUE_APP_MANAGER_HH_SERVICES_ENABLED !== 'false'
